import LoginPage from './Page';
export default LoginPage;
